export enum RoleTypes {
  Owner = 'owner',
  Writer = 'writer',
  Reader = 'reader',
}
